var map = {
	"./aiSecurity/cn.json": [
		3624,
		52
	],
	"./dataLeakage/cn.json": [
		3625,
		55
	],
	"./ppd/cn.json": [
		3626,
		58
	],
	"./ransomware/cn.json": [
		3627,
		61
	],
	"./socialMedia/cn.json": [
		3628,
		64
	],
	"./whatsApp/cn.json": [
		3629,
		67
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 605;
module.exports = webpackAsyncContext;